import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, UserResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetUsersListCommand extends IRequestCommand<
  IGetUsersListResponse,
  ErrorDetails,
  IGetUsersListCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'users/paginated/?page={page}&size={size}&column={column}&sort={sort}&find={find}';
  public override setParameters(parameters: IGetUsersListCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{find}',
      parameters.find.toString()
    );
  }
}

export interface IGetUsersListCommandParameters extends ICommandParameters {
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  find?: string;
}

export interface IGetUsersListResponse
  extends UserResponseDTO,
    ICommandResponse {}
